import React, { Fragment } from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Accordion } from 'core/controls';
import { TranslateContext } from 'core/translate';
import SimpleOptionGroup from '../common/options/SimpleOptionGroup';
import OptionsPage from '../common/OptionsPage';
import { createModelInfo } from '../common/ModelInfoContext';

const Exterior = ({ options, mechanical, wheels, tires, safety }) => {
  return (
    <OptionsPage>
      {({ onChange, onDetails }) => (
        <Accordion>
          <TranslateContext.Consumer>
            {translate => (
              <Fragment>
                <SimpleOptionGroup
                  header={translate('component.common.select.wheels')}
                  options={wheels}
                  disableSingleOption={true}
                  id="exterior-wheels"
                  onChange={onChange}
                  onDetails={onDetails}
                />
                <SimpleOptionGroup
                  header={translate('component.common.select.tires')}
                  options={tires}
                  disableSingleOption={true}
                  id="exterior-tires"
                  onChange={onChange}
                  onDetails={onDetails}
                />
                <SimpleOptionGroup
                  header={translate(
                    'component.common.select.exterior.mechanical'
                  )}
                  options={mechanical}
                  id="exterior-mechanical"
                  onChange={onChange}
                  onDetails={onDetails}
                />
                <SimpleOptionGroup
                  header={translate('component.common.select.exterior.options')}
                  options={options}
                  id="exterior-options"
                  onChange={onChange}
                  onDetails={onDetails}
                />
                <SimpleOptionGroup
                  header={translate('component.common.select.exterior.safety')}
                  options={safety}
                  id="exterior-safety"
                  onChange={onChange}
                  onDetails={onDetails}
                />
              </Fragment>
            )}
          </TranslateContext.Consumer>
        </Accordion>
      )}
    </OptionsPage>
  );
};

const filterTransmissions = mechanicalOptions => matrixTrans =>
  mechanicalOptions.filter(x => !_.some(matrixTrans, { id: x.id }));

const mapStateToProps = state => {
  const { enableTrimFiltering } = createModelInfo();
  const exteriorOptions = state.config.exterior;
  const mechanicalOptions = _.get(exteriorOptions, 'exterior.mechanical', []);
  let matrixTrans = {};

  if (enableTrimFiltering) {
    matrixTrans = Object.assign({}, state.matrix.transmissions);
  }

  return {
    options: _.get(exteriorOptions, 'exterior.options', []),
    mechanical: enableTrimFiltering
      ? filterTransmissions(mechanicalOptions)(matrixTrans)
      : mechanicalOptions,
    wheels: _.get(exteriorOptions, 'exterior.wheels', []),
    tires: _.get(exteriorOptions, 'exterior.tires', []),
    safety: _.get(exteriorOptions, 'exterior.safety', [])
  };
};

export default withRouter(connect(mapStateToProps)(Exterior));
